module.exports = __webpack_public_path__ + "static/media/hanneke_knol_zittend.d92e7128.png";